<template>
  <a-modal
    v-model:open="open"
    destroyOnClose
    :maskClosable="false"
    :width="656"
    :footer="null"
  >
    <template #title>
      <div class="text-center">{{ $t('pai-dui-jia-su') }}</div>
    </template>
    <a-spin :spinning="loading">
      <a-alert
        :message="
          canAddSpeed
            ? $t('yi-dan-kou-fei-sheng-xiao-bu-ke-tui-hui')
            : $t(
                'nin-dang-qian-yi-wei-yu-pai-dui-shou-wei-wu-xu-shi-yong-jia-su-bao-jin-hang-pai-dui-jia-su'
              )
        "
        type="warning"
        show-icon
        class="!my-[30px]"
      />
      <div class="detail">
        <!-- <div class="description">
          <div class="label">
            <span>{{ $t('jin-ri-pai-dui') }}</span>
            <a-tooltip
              :title="
                $t(
                  'quan-ping-tai-ge-ren-ban-mei-ri-30-ge-pai-dui-jia-su-minge0-dian-shua-xin-shou-wan-wei-zhi'
                )
              "
            >
              <span class="align-middle ml-[2px]">
                <iconpark-icon name="info-fill" size="16"></iconpark-icon>
              </span>
            </a-tooltip>
          </div>
          <div class="content">
            <a-progress
              :percent="percent"
              :format="
                () =>
                  `${preview?.current_speed_count}/${preview?.total_speed_count}`
              "
            />
          </div>
        </div> -->
        <div class="description">
          <div class="label">
            <span>{{ $t('dang-qian-zhuang-tai') }}</span>
          </div>
          <div class="content">
            {{ $t('yu-ji-deng-dai')
            }}{{ getFormateTime(preview?.old_queue_wait_time) }}
          </div>
        </div>
        <div class="description">
          <div class="label">
            <span>{{ $t('pai-dui-jia-su-hou') }}</span>
          </div>
          <div class="content">
            <span>
              {{ $t('yu-ji-deng-dai') }}
              {{ getFormateTime(preview?.new_queue_wait_time) }}
            </span>
            <span v-if="canAddSpeed" class="highlight">
              （{{ $t('ti-su')
              }}{{
                reduceTime(
                  preview?.old_queue_wait_time,
                  preview?.new_queue_wait_time
                )
              }}{{ $t('fen-zhong') }}）
            </span>
            <span v-else class="highlight">
              {{ $t('nin-yi-wei-yu-dui-lie-di-1-wei-wu-xu-ti-su') }}
            </span>
          </div>
        </div>
      </div>
      <div class="footer">
        <a-space v-if="canAddSpeed">
          <a-button @click="showModal">{{ $t('qu-xiao') }}</a-button>
          <a-button type="primary" :loading="confirmLoading" @click="handleOk">
            <span>
              <iconpark-icon
                name="lightning"
                size="16"
                class="align-sub"
              ></iconpark-icon>
            </span>
            <span>
              {{ $t('pai-dui-jia-su') }}（{{ consumption }}{{ $t('yan-bi') }}）
            </span>
          </a-button>
          <!-- <a-tooltip
            v-if="allowAccelerate"
            :title="$t('yan-bi-bu-zu-qing-chong-zhi-hou-zai-lai-xiao-fei')"
          >
            <span class="align-middle ml-[2px]">
              <iconpark-icon name="info-fill" size="16"></iconpark-icon>
            </span>
          </a-tooltip> -->
        </a-space>
        <a-button v-else type="primary" @click="showModal">
          {{ $t('zhi-dao-le') }}
        </a-button>
      </div>
    </a-spin>
  </a-modal>
</template>
<script lang="ts" setup>
import {
  accelerateTask,
  getAccelerateTaskPreview,
  getCurrentYanBi,
} from '~/api'
import { showContact } from '~/hooks/useModal/modals/contact'
import { useTime } from '~/hooks/useTime'

const open = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
const emits = defineEmits(['reload'])
const userInfo = useUserInfo()
const preview = ref<any>({
  current_speed_count: 0,
  total_speed_count: 30,
  old_queue_wait_time: 0,
  new_queue_wait_time: 0,
})
const disabled = ref<boolean>(true)
const loading = ref<boolean>(false)
const allowAccelerate = ref<boolean>(false)
const { getFormateTime } = useTime()

const percent = computed(() =>
  Math.floor(
    (preview.value?.current_speed_count / preview.value?.total_speed_count) *
      100
  )
)

const canAddSpeed = computed(
  () => preview.value?.old_queue_wait_time > preview.value?.new_queue_wait_time
)

// 判断当前用户所在队列位置
// const upPosition = computed(
//   () =>
//     preview.value?.old_pending_task_count >
//       preview.value?.new_pending_task_count &&
//     preview.value?.new_pending_task_count
// )

const showModal = () => {
  open.value = !open.value
}

const reduceTime = (startTime: number, endTime: number) =>
  Math.floor(
    (Math.ceil(startTime / 60) * 60 - Math.ceil(endTime / 60) * 60) / 60
  )
// const TAST_CONSUMPTION = 0 // 每次消耗言币数量，后端返回
const consumption = computed(
  () => userInfo?.value?.rights_record?.speed_up_coin
)

const fetchCurrentYanBi = async (values: any) => {
  try {
    const response: any = await getCurrentYanBi({
      consumption_behavior: 20,
      generate_record_id: values?.generate_record_id,
    })
    if (response.code === 0) {
      // disabled.value = !(
      //   response.data?.remained >= (response?.data?.need ?? TAST_CONSUMPTION)
      // )
      allowAccelerate.value = !(
        response.data?.remained >= (response?.data?.need ?? consumption.value)
      )
      // consumption.value = response?.data?.need ?? TAST_CONSUMPTION
    }
  } catch (error) {
    console.error(error)
  }
}

const handleGetAccelerateTaskPreview = async (values: any) => {
  if (!values?.id) {
    return
  }
  loading.value = true
  // await fetchCurrentYanBi(values)
  try {
    const response: any = await getAccelerateTaskPreview({
      id: values?.id,
    })
    showModal()

    if (response.code === 0) {
      preview.value = { ...response.data, ...values }
      loading.value = false
    }
  } catch (error) {
    console.error(error)

    disabled.value = true
    loading.value = false
  }
}
const { $t } = useNuxtApp()

const handleOk = async () => {
  await fetchCurrentYanBi(preview.value)
  if (allowAccelerate.value) {
    const text = h(
      'a',
      { class: 'ml-[50px]', onClick: () => showContact() },
      $t('lian-xi-wo-men')
    )

    return message.error({
      content: h('div', [
        $t('yan-bi-bu-zu-qing-lian-xi-nin-de-shang-wu-fu-ze-ren'),
        text,
      ]),
      duration: 3,
    })
  }

  confirmLoading.value = true
  try {
    const response: any = await accelerateTask({ id: preview.value?.id })
    if (response?.code === 0) {
      open.value = false
      message.success(
        $t('kou-kuan-cheng-gong-cheng-pian-jia-su-cheng-gong', [
          preview.value?.title,
        ])
      )
      emits('reload')
    }
  } catch (error) {
    console.error(error)
  } finally {
    confirmLoading.value = false
  }
}

defineExpose({
  open: handleGetAccelerateTaskPreview,
})
</script>
<style lang="scss" scoped>
.detail {
  @apply flex flex-col gap-[30px] mb-[83px] mr-[20px];
}

.footer {
  @apply w-full flex justify-center items-center;
}
.description {
  @apply w-full flex flex-nowrap text-14 text-[var(--font-color-1)];
  .label {
    @apply font-normal w-[100px];
  }
  .content {
    @apply flex-1 font-medium;
  }
}
.highlight {
  @apply text-primary;
}
</style>
